import { useEffect } from "react";
import { createUseStyles } from "react-jss";
import Label from "../../refresh/Label";
import { useMediaSelector } from "../../refresh/selectors/MediaSelector";
import styles from "../types/sharedStyles";

const useStyles = createUseStyles({ ...styles });

const ImageElement = ({ value, onChange }) => {
  const [media, getMedia] = useMediaSelector(value.image ?? {});
  const classes = useStyles();

  useEffect(() => {
    if (media.id) {
      onChange({
        image: {
          id: media.id,
          name: media.title,
          preview_url: media.preview_url,
        },
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [media.id]);

  return (
    <>
      <Label name="Image" required>
        <div className={classes.genericSelector}>
          <div
            style={{
              backgroundImage: `url("${
                media.preview_url || media.public_url || ""
              }")`,
            }}
          />
          <p>{media.name || media.title || "Select an image"}</p>
          <button onClick={() => getMedia([1])}>Select from CMS</button>
        </div>
      </Label>
    </>
  );
};

export default ImageElement;
